export interface ModalControl {
  modal_state: boolean;
  close_modal: () => void;
}

export const MODAL_CLOSE_TIMEOUT_NONE = 0;
export const MODAL_CLOSE_TIMEOUT_ANIMATED = 500;
